import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactInfo = () => {
  const contactMethods = [
    {
      icon: 'Phone',
      title: 'Phone',
      primary: '+91 99256 27972',
      secondary: '+91 88666 25488',
      action: 'tel:+919925627972',
      secondaryAction: 'tel:+919925627972',
      description: 'Mon-Sat 9AM-7PM IST'
    },
    {
      icon: 'Mail',
      title: 'Email',
      primary: 'info@zentirx.com',
      //secondary: '',
      action: 'mailto:info@zentirx.com',
      description: 'We respond within 24 hours'
    },
    {
      icon: 'MapPin',
      title: 'Address',
      primary: '35, Meridian Business Center (MBC), Lajamani chowk, Motavarachha (Digital Valley), Surat',
      //secondary: '',
      description: 'Visit our headquarters'
    },
    {
      icon: 'Clock',
      title: 'Business Hours',
      primary: 'Monday - Saturday: 9:00 AM - 7:00 PM IST',
      description: 'Indian Standard Time (IST)'
    }
  ];

  const socialLinks = [
    {
      name: 'LinkedIn',
      icon: 'Linkedin',
      url: 'https://www.linkedin.com/company/zentirx',
      color: 'text-blue-600'
    },
    // {
    //   name: 'Twitter',
    //   icon: 'Twitter',
    //   url: 'https://twitter.com/zentirx',
    //   color: 'text-blue-400'
    // },
    // {
    //   name: 'GitHub',
    //   icon: 'Github',
    //   url: 'https://github.com/zentirx',
    //   color: 'text-gray-800'
    // },
    // {
    //   name: 'Facebook',
    //   icon: 'Facebook',
    //   url: 'https://facebook.com/zentirx',
    //   color: 'text-blue-600'
    // }
  ];

  const teamContacts = [
    {
      name: 'Sarah Johnson',
      role: 'Business Development',
      email: 'sarah@zentirx.com',
      phone: '+1 (555) 012-3458',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Michael Chen',
      role: 'Technical Lead',
      email: 'michael@zentirx.com',
      phone: '+1 (555) 012-3459',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Emily Rodriguez',
      role: 'Project Manager',
      email: 'emily@zentirx.com',
      phone: '+1 (555) 012-3460',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
    }
  ];

  // Dynamic Map Info
  const mapInfo = {
    title: 'Surat Headquarters',
    address: '35, Meridian Business Center (MBC), Lajamani chowk, Motavarachha, Surat',
    latitude: 21.2386432,
    longitude: 72.8896148,
    phone: '+91 99256 27972'
  };

  return (
    <div className="space-y-8">
      {/* Contact Information */}
      <div className="bg-surface rounded-lg card-shadow-lg p-6">
        <h3 className="text-2xl font-heading font-bold text-text-primary mb-6">
          Contact Information
        </h3>
        
        <div className="space-y-6">
          {contactMethods.map((method, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="w-10 h-10 bg-primary-50 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={method.icon} size={20} className="text-primary" />
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-text-primary mb-1">
                  {method.title}
                </h4>
                {method.action ? (
                  <a
                    href={method.action}
                    className="text-primary hover:text-primary-700 font-medium block"
                  >
                    {method.primary}
                  </a>
                ) : (
                  <p className="text-text-primary font-medium">
                    {method.primary}
                  </p>
                )}
                {method.secondaryAction ? (
                  <a
                    href={method.secondaryAction}
                    className="text-primary hover:text-primary-700 font-medium block"
                  >
                    {method.secondary}
                  </a>
                ) : (
                  <p className="text-text-primary font-medium">
                    {method.secondary}
                  </p>
                )}
                <p className="text-text-secondary text-sm mt-1">
                  {method.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Map Section */}
        <div className="mt-8">
          <h4 className="text-xl font-semibold text-text-primary mb-3">
            Location Map
          </h4>
          <div className="relative bg-secondary-100 rounded-lg overflow-hidden" style={{ height: '300px' }}>
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title={mapInfo.title}
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps?q=${mapInfo.latitude},${mapInfo.longitude}&z=14&output=embed`}
              className="border-0"
            />
            
            {/* Map Overlay with Office Info */}
            <div className="absolute top-4 left-4 bg-surface rounded-lg p-3 card-shadow max-w-xs">
              <h6 className="font-semibold text-text-primary text-sm mb-1">
                {mapInfo.title}
              </h6>
              <p className="text-text-secondary text-xs">
                {mapInfo.address}
              </p>
              <div className="flex items-center space-x-4 mt-2">
                <a
                  href={`https://maps.google.com/?q=${mapInfo.latitude},${mapInfo.longitude}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:text-primary-700 text-xs font-medium flex items-center"
                >
                  <Icon name="ExternalLink" size={12} className="mr-1" />
                  Directions
                </a>
                <a
                  href={`tel:${mapInfo.phone}`}
                  className="text-primary hover:text-primary-700 text-xs font-medium flex items-center"
                >
                  <Icon name="Phone" size={12} className="mr-1" />
                  Call
                </a>
              </div>
            </div>
          </div> 
        </div>
      </div>

      {/* Social Media */}
      <div className="bg-surface rounded-lg card-shadow-lg p-6">
        <h3 className="text-xl font-heading font-bold text-text-primary mb-4">
          Follow Us
        </h3>
        <p className="text-text-secondary mb-6">
          Stay connected with us on social media for the latest updates and insights.
        </p>
        
        <div className="flex flex-wrap gap-4">
          {socialLinks.map((social, index) => (
            <a key={index} href={social.url} target="_blank" rel="noopener noreferrer"
              className={`flex items-center space-x-2 px-4 py-2 bg-secondary-50 hover:bg-secondary-100 rounded-md transition-colors duration-150 focus-ring ${social.color}`}
            >
              <Icon name={social.icon} size={18} />
              <span className="text-sm font-medium text-text-primary">
                {social.name}
              </span>
            </a>
          ))}
        </div>
      </div>

      {/* Team Contacts */}
      {/* <div className="bg-surface rounded-lg card-shadow-lg p-6">
        <h3 className="text-xl font-heading font-bold text-text-primary mb-4">
          Direct Team Contacts
        </h3>
        <p className="text-text-secondary mb-6">
          Reach out directly to our team members for specific inquiries.
        </p>
        
        <div className="space-y-4">
          {teamContacts.map((member, index) => (
            <div key={index} className="flex items-center space-x-4 p-4 bg-secondary-50 rounded-lg">
              <img
                src={member.avatar}
                alt={member.name}
                className="w-12 h-12 rounded-full object-cover"
                onError={(e) => {
                  e.target.src = "/assets/images/no_image.png";
                }}
              />
              <div className="flex-1">
                <h4 className="font-semibold text-text-primary">
                  {member.name}
                </h4>
                <p className="text-sm text-text-secondary mb-2">
                  {member.role}
                </p>
                <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-1 sm:space-y-0">
                  <a
                    href={`mailto:${member.email}`}
                    className="text-sm text-primary hover:text-primary-700 flex items-center"
                  >
                    <Icon name="Mail" size={14} className="mr-1" />
                    {member.email}
                  </a>
                  <a
                    href={`tel:${member.phone}`}
                    className="text-sm text-primary hover:text-primary-700 flex items-center"
                  >
                    <Icon name="Phone" size={14} className="mr-1" />
                    {member.phone}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default ContactInfo;
